import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BreadcrumbItem {
  id: number;
  name: string;
  path: string;
}

interface BreadcrumbState {
  breadcrumbs: BreadcrumbItem[];
}

const initialState: BreadcrumbState = {
  breadcrumbs: [],
};

const breadcrumbSlice = createSlice({
  name: "breadcrumbs",
  initialState,
  reducers: {
    addBreadcrumbs: (state, action: PayloadAction<BreadcrumbItem[]>) => {
      // Prevent duplicate breadcrumbs
      action.payload.forEach((breadcrumb) => {
        if (!state.breadcrumbs.some((b) => b.id === breadcrumb.id)) {
          state.breadcrumbs.push(breadcrumb);
        }
      });
    },
    removeBreadcrumbs: (state, action: PayloadAction<number[]>) => {
      state.breadcrumbs = state.breadcrumbs.filter(
        (b) => !action.payload.includes(b.id)
      );
    },
    resetBreadcrumbs: (state) => {
      state.breadcrumbs = [];
    },
  },
});

export const { addBreadcrumbs, removeBreadcrumbs, resetBreadcrumbs } = breadcrumbSlice.actions;
export default breadcrumbSlice.reducer;
